export default __webpack_public_path__ + "static/media/hope_at _last.c2ef0960.webp";